<template>
    <div class="wrapper">
        <div class="main-panel">
            <div class="content">
                <div class="container-fluid">
                    <slot />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Wrapper"
    }
</script>

<style>
    .main-panel{
        background-color: #fbfbfc;

    }
    body{
        background-color: #fbfbfc!important;
    }
</style>